<template>
  <div>
    <v-card-title>
      <v-spacer></v-spacer>
      <div class="flex">
        <v-row style="justify-content: flex-end;">
          <v-col cols="6" md="3" sm="6">
            <v-select
              solo
              @change="getWorkSheet()"
              :items="subjects"
              item-text="subject_name"
              item-value="subject_code"
              label="Select Subject"
              v-model="data.subject"
            ></v-select>
          </v-col>
          <v-col cols="6" md="3" sm="6">
            <v-select
              solo
              @change="getWorkSheet()"
              :items="classes"
              item-text="class_name"
              item-value="class_id"
              label="Select Class"
              v-model="data.class_id"
            ></v-select>
          </v-col>
        </v-row>
      </div>
    </v-card-title>
    <v-simple-table style="overflow:scroll">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              Month
            </th>
            <th class="text-left">
              Week 1
            </th>
            <th class="text-left">
              Week 2
            </th>
            <th class="text-left">
              Week 3
            </th>
            <th class="text-left">
              Week 4
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-if="Object.keys(WorkSheet).length > 0">
            <tr v-for="(item, index) in WorkSheet" :key="index">
        
                 <td >{{index.match(/\(([^)]+)\)/)[1]}}</td>

              <template v-for="(row, index) in setValue(item)">
                <td :key="index">
                  <template v-if="row != '-'">
                    <template v-for="(data, index) in row">
                      <p :key="index">
                        <a @click="openDialog(data)">{{
                          data.work_sheet_code + '(Ans)'
                        }}</a>
                      </p>
                    </template>
                  </template>
                  <template v-else>
                    <td>-</td>
                  </template>
                </td>

                <!-- <template v-if="index == 1"> -->
                <!-- <td :key="index">
                  {{ row.week }}
                </td>
              </template>
                  <template v-else>
                <td :key="index">
                    -
                </td>
              </template> -->
              </template>
            </tr>
          </template>
          <template v-else>
            <tr class="text-center">
              <td colspan="5">No record found</td>
            </tr>
          </template>
        </tbody>
      </template>
    </v-simple-table>
    <v-snackbar v-model="snackbar" top right color="success" v-if="snackbar">
      {{ snackbarMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false"
          >X</v-btn
        >
      </template>
    </v-snackbar>
    <!-- <delete-dialog
      @success="del"
      :confirm-loading="deleteConfirmLoading"
      @closeDialog="cancelDelete"
      :dialog="delete_dialog"
      title="Work Sheet"
    ></delete-dialog> -->
      <v-row justify="center">
    <v-dialog
      v-model="dialog"
    
       max-width="900"
        hide-overlay
     
      scrollable
    >
    
      <v-card>
        <v-card-title class=" justify-center">
          <span class="headline justify-center"> {{student_name}}</span>
         
       
        </v-card-title>
        <v-card-text>
       
   
        <div style="width: 100%; height: 1000px position: relative;">

        <iframe :src="this.src"
              frameborder="0" scrolling="no" seamless="" style="width: 100%; height: 100vh">
              <p>Your browser does not support iframes.</p>
        </iframe>
        <div style="width: 100%; height: 180px; position: absolute; background-color:blue; opacity: 0; right: 0px; top: 0px;"></div>
        </div>
        </v-card-text>
        <v-card-actions >
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog = false, src=null"
          >
            Close
          </v-btn>
        
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  </div>
</template>
<script>
import DeleteDialog from "../Dialogs/DeleteDialog";
import DeleteRow from "../../mixins/deleteRow";
import { bus } from '../../main';
export default {
  name: "WorkSheetChart",
  components: {
    DeleteDialog,
  },
  mixins: [DeleteRow],
  data() {
    return {
       url: process.env.VUE_APP_BASE_URL,
         dialog: false,
      src:'',
      subjects: [],
      snackbarMessage: "",
      snackbar: false,
      WorkSheet: {},
      weeks: [{ name: " 1" }, { name: " 2" }, { name: " 3" }, { name: " 4" }],

      data: {
        subject: "",
        class_id: "",
      },
      
    };
  },

  methods: {
     openDialog(item){
       console.log(item.work_sheet,"hghj")
      this.dialog=true;
      // &output=[pdf]
      //  :href="`https://view.officeapps.live.com/op/view.aspx?src= http://prelive.qslearning.co.uk/public/storage/workSheet/-FlzuoD1WUKtgAg2uH63hVGmE9gj7ndGp7Q6Inrru.docx&embedded=true&output=[pdf]`"

      //  :href="`https://view.officeapps.live.com/op/view.aspx?src=${getBaseURL}/storage/${sheet.work_sheet}`"
      // this.src = 'https://docs.google.com/viewerng/viewer?url=http://prelive.qslearning.co.uk/public/storage/workSheet/-iW2jD9iXpSTesiF7c0lWvF3Xcjr00ahq5xm7eIhp.docx&embedded=true';
      this.src = `https://view.officeapps.live.com/op/view.aspx?src=${this.url}/storage/${item.work_sheet}&embedded=true`;
      // this.src = `https://view.officeapps.live.com/op/view.aspx?src=http://prelive.qslearning.co.uk/public/storage/workSheet/-VPrvuYYsmC0vK43WzEzcM835YWpEe7nUlWel67iq.docx&embedded=true`;
    //  window.getElementById('#AppHeaderPanel').style.dispaly = 'none';
      this.student_name= item.student_fname
    },
    cancelDelete() {
      this.deleteConfirmLoading = false;
      this.delete_dialog = false;
    },
    del() {
      //  console.log(this.current_row);
      axios
        .post(apiRoutes.WorkSheet.del, { id: this.current_row.work_sheet_id })
        .then((response) => {
          this.snackbar = true;
          this.snackbarMessage = response.data.response;
          this.deleteConfirmLoading = false;
          this.delete_dialog = false;
          this.getWorkSheet();
        })
        .catch((response) => {
          if (response.status === 422) {
            this.deleteConfirmLoading = false;
            this.delete_dialog = false;
            this.errors = response.data.errors;
          }
        });
    },
    setValue(data) {
      //   console.log(data);
      var newRecord = [];

      for (var i = 0; i <= 3; i++) {
        if (data[i + 1]) {
          newRecord[i] = data[i + 1];
        } else {
          newRecord[i] = "-";
        }
      }
      //  console.log(newRecord,'new ec');
      return newRecord;
    },

    getWorkSheet() {
      axios
        .post(apiRoutes.WorkSheet.answerSheet, this.data)
        .then((response) => {
          console.log(response);
          this.WorkSheet = response.data.response;
        })
        .catch((response) => {
          if (response.status === 422) {
            this.errors = response.data.errors;
          }
        });
    },
    getSubject() {
      axios.get(apiRoutes.subjects.url).then((response) => {
        // console.log(response);
        this.subjects = response.data.response;
        // console.log(this.subjects);
        this.loading = false;
      });
    },
    getItems() {
      axios.get(apiRoutes.classes.url).then((response) => {
        this.classes = response.data.response;
        this.loading = false;
      });
    },
  },

  mounted() {
    this.getItems();
    this.getSubject();
    this.getWorkSheet();
  },
   created(){
      bus.$on('workSheetUpload', (data) => {
     this.getWorkSheet();
    })
  }
};
</script>
